import { Icon } from '@ps/isp-web-component-library';
import { StarSubIcon } from '@ps/isp-web-component-library/icons/StarSubIcon';
import type { MarketType } from '@ps/isp-web-services-types';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { MatchMarketIcons } from '@swf/sports/components';
import BetBuilderIcon from '@swf/sports/components/BetBuilderIcon/BetBuilderIcon';

import { TXTWCL_STAR_SUB, TXTWCL_Star_Sub_selections } from './MarketTitleWithIcons.messages.json';
import styles from './MarketTitleWithIcons.scss';

interface Props {
  title: React.ReactNode;
  isSgmEligible?: boolean;
  isStarSubEnabled?: boolean;
  marketType?: MarketType;
}

const MarketTitleWithIcons: React.FC<Props> = ({
  title,
  isSgmEligible,
  isStarSubEnabled,
  marketType
}) => {
  const { formatMessage } = useRegulatoryIntl();
  const starSubIconLabel = formatMessage(TXTWCL_Star_Sub_selections);
  const isBetBuilderEnabled = useFeature(FeatureFlag.ISPBetBuilder);
  return (
    <span className={styles.marketIconStarSubTitle}>
      {title}
      {isSgmEligible && isBetBuilderEnabled && (
        <div className={styles.container}>
          <BetBuilderIcon />
        </div>
      )}
      {isStarSubEnabled && (
        <div className={styles.marketIcon}>
          <Icon icon={StarSubIcon} label={starSubIconLabel} size="sm" />
          <span className={styles.marketIconStarSubTitleBadge} aria-hidden="true">
            <Translation {...TXTWCL_STAR_SUB} />
          </span>
        </div>
      )}
      <div className={styles.marketIcon}>
        <MatchMarketIcons marketType={marketType} size="base" />
      </div>
    </span>
  );
};

export default MarketTitleWithIcons;
